import { useCallback, useRef, useState } from "react";
import { useAuth } from "@/context/AuthContext";

// Like useState, but remembered per user on the server.
export function usePref(key, initial) {
  const { prefs, setPref } = useAuth();
  const [value, setValue] = useState(() => (prefs && prefs[key] !== undefined ? prefs[key] : initial));
  const ref = useRef(value);
  const set = useCallback((v) => {
    const next = typeof v === "function" ? v(ref.current) : v;
    ref.current = next;
    setValue(next);
    setPref(key, next);
  }, [key, setPref]);
  return [value, set];
}
